<div class="msg">
    <div class="bubble" [class.me]="message.isAuthor">
        <div class="txt">
            <span class="name">{{ message.author }}</span>
            <span class="timestamp">{{ message.createDate | dateClosest | lowercase }}</span>
            <div class="message" *ngIf="message.content && !message.linkUrl && !message.path" [innerHTML]="message.content | emojify"></div>
            <span class="file" *ngIf="message.path" (click)="onDownloadClicked(message)">
                <div fxLayout="row" fxLayoutAlign="start center" >
                    <div class="link-icon">
                        <i class="material-icons">
                            cloud_download
                        </i>
                    </div>
                    <div>
                        <div fxLayout="column" fxLayoutAlign="center start" >
                            <div class="link-title">
                                {{ 'Download' | translate }}
                            </div>
                            <div class="link-url">
                                {{ message.content }}
                            </div>
                        </div>
                    </div>
                </div>
            </span>
            <div class="shared-link" *ngIf="message.linkUrl" (click)="onLinkClicked(createLink())">
                <div fxLayout="row" fxLayoutAlign="start center" >
                    <div class="link-icon">
                        <i class="material-icons">
                            link
                        </i>
                    </div>
                    <div>
                        <div fxLayout="column" fxLayoutAlign="center start" >
                            <div class="link-title">
                                {{ message.linkTitle }}
                            </div>
                            <div class="link-url">
                                {{ createLink() }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bubble-arrow"></div>
    </div>
</div>
